import merge from 'lodash/merge'
import BaseChartSeries from "./baseSeries"
import { ChartCandle } from "../chart.typings"
import { VolumeCandleData } from "../customSeries/volumeCandleSeries/data"
import { VolumeCandleSeriesOptions } from "../customSeries/volumeCandleSeries/options"
import { VolumeCandleSeries as CustomVolumeCandleSeries } from "../customSeries/volumeCandleSeries/volumeCandleSeries"
import { volumeCandleSeriesOptions } from "../../../assets/constants"

class VolumeCandleSeries extends BaseChartSeries<VolumeCandleData, VolumeCandleSeriesOptions> {
    customPaneView?: CustomVolumeCandleSeries

    init() {
        this.customPaneView = new CustomVolumeCandleSeries();
    }

    addSeriesToChart() {
        return this.createCustomSeries(this.customPaneView!, this.seriesOptions)
    }

    getDefaultOptions(): VolumeCandleSeriesOptions {
        return merge(volumeCandleSeriesOptions, this.options)
    }

    getPrimaryData(length = 0): ChartCandle[] {
        return (length > 0 ? this.data.slice(-length) : this.data) as unknown as ChartCandle[];
    }

    generateSeriesData(data: ChartCandle[], metadata: Record<string, any> = {}, update = false): VolumeCandleData[] {
        return data.map(d => ({
            time: d.time,
            open: d.open,
            high: d.high,
            low: d.low,
            close: d.close,
            volume: d.volume ?? 0
        }))
    }
}

export default VolumeCandleSeries
